module.exports = __webpack_public_path__ + "img/login1.af918db3.png";